import { AdapterRegistry } from 'app/model/adapters/adapter-registry';
import { Model } from 'app/model/backendmodel';
import { Metamodel } from 'app/model/base/model';

import { CopySourceAdapter, commonCopySourceAdapts } from './copysource.adapter';
import { CopyActivity } from 'app/model/pipeline/copy.activity';
import { ValueAdapter } from 'app/model/adapters/value.adapter';
import { CassandraCopySource } from 'app/model/pipeline/copysource/cassandra.copysource';

@AdapterRegistry.adapter({
    model: Metamodel.modelFor(CassandraCopySource),
    asynchronous: true,
    adapts: {
        ...commonCopySourceAdapts,
        query: '*',
        consistencyLevel: '*'
    }
})
export class CassandraCopySourceAdapter extends CopySourceAdapter<CassandraCopySource, Model.CassandraSource> {
    protected override async _toResource(copySource: CassandraCopySource): Promise<Model.CassandraSource> {
        const result: Model.CassandraSource = this.getCommonCopySourceProperties(copySource, 'CassandraSource');
        if (copySource.mode === 'query') {
            result.query = ValueAdapter.toResource(copySource, CassandraCopySource.READER_QUERY);
        }
        result.consistencyLevel = ValueAdapter.toResource(copySource, CassandraCopySource.CONSISTENCY_LEVEL);
        return result;
    }

    protected override async _toModel(
        resource: Model.CassandraSource,
        copyActivity: CopyActivity
    ): Promise<CassandraCopySource> {
        const result = this.createCopySourceWithCommonProperties(
            CassandraCopySource.MODEL,
            resource,
            copyActivity
        ) as CassandraCopySource;
        if (resource.query) {
            ValueAdapter.toModel(result, CassandraCopySource.READER_QUERY, resource.query);
            result.mode = 'query';
        }
        if (resource.consistencyLevel) {
            if (typeof resource.consistencyLevel === 'string') {
                ValueAdapter.toModel(
                    result,
                    CassandraCopySource.CONSISTENCY_LEVEL,
                    resource.consistencyLevel.toLocaleLowerCase()
                );
            } else {
                ValueAdapter.toModel(result, CassandraCopySource.CONSISTENCY_LEVEL, resource.consistencyLevel);
            }
        }
        return result;
    }
}
